module.exports = __webpack_public_path__ + "static/media/restaurantheader-min.0532215c.png";